import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SignIn } from './pages/SignIn.js';
import { ConfirmSignIn } from './pages/ConfirmSignIn.js';
import { AppShell } from './pages/AppShell.js';
import { AnalysisView } from './pages/AnalysisView.js';
import { AnalysesList } from './pages/AnalysesList.js';
import { AdminMembers } from './pages/AdminMembers.js';
import { StandardsQueue } from './pages/StandardsQueue.js';
import { ProjectsList } from './pages/ProjectsList.js';
import { ProjectView } from './pages/ProjectView.js';
import { NewProject } from './pages/NewProject.js';
import { AppHeader } from './components/AppHeader.js';
import { ChromeProvider, SurfaceProvider } from './chrome.js';

// Routes: the public sign-in page, the magic-link confirm page, the authed home (deal entry), and a
// live analysis result. The api's GET /auth/verify no longer consumes the token — it redirects the
// clicked link here (/auth/confirm), where an explicit "Confirm sign-in" click POSTs the token so a
// mail-scanner pre-fetch can't burn it (POST-to-confirm hardening). CloudFront serves index.html for
// unknown paths (SPA fallback, PR-C), so /auth/confirm and the deep-linkable /analyses/:id reload cleanly.
export function App() {
  return (
    // The Deal Analyzer's chrome, supplied once here. `ProjectsList`, `ProjectView`, `NewProject`
    // and `StandardsQueue` are rendered by the Hub too, so the header is the APPLICATION's to
    // choose and not the page's — see `chrome.tsx`.
    <ChromeProvider value={AppHeader}>
      {/* The analyzer surface — client-facing, so Hub-only features stay off it (see chrome.tsx). */}
      <SurfaceProvider value="analyzer">
        <BrowserRouter>
          <Routes>
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/auth/confirm" element={<ConfirmSignIn />} />
            <Route path="/" element={<AppShell />} />
            <Route path="/analyses" element={<AnalysesList />} />
            <Route path="/analyses/:id" element={<AnalysisView />} />
            <Route path="/projects" element={<ProjectsList />} />
            <Route path="/standards" element={<StandardsQueue />} />
            <Route path="/admin/members" element={<AdminMembers />} />
            {/*
          `/projects/new` must not be read as a project whose CODE is "new". React Router ranks a
          static segment above a dynamic one regardless of declaration order, so this is correct as
          written — but it is stated here because the two routes are one typo apart, and the failure
          would be a 404 on the intake form rather than anything that looks like a routing bug.
        */}
            <Route path="/projects/new" element={<NewProject />} />
            <Route path="/projects/:code" element={<ProjectView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SurfaceProvider>
    </ChromeProvider>
  );
}
